<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <HeaderTop/>    
      <div role="main" class="main">
        <router-view></router-view>
      </div>

</template>
<script>
import HeaderTop from './../components/Header.vue'
var currentURL = (document.URL);
const sgid = currentURL.split('://')[1].split('/')[3];
const uuid = currentURL.split('://')[1].split('/')[2];

export default {
  name: 'HomeLayout',
  components: {
    HeaderTop,
  },
  data() {
    return {
      sgid:sgid,
      uuid:uuid,
    }
  },
  mounted () {
  }
}
</script>


<style>
.main{
  margin: 90px auto;
}
#app {
  font-family: "Noto Sans TC", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>